// @flow

import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import TabRouter from '@westfieldcorp/tab-router';

import {
  MALL_MEDIA_BROCHURE,
  MALL_MEDIA_LAYOUT,
  MALL_MEDIA_PICTURE,
  MALL_MEDIA_VIDEO,
  MALL_MEDIA_VISIT,
} from '../../../path/mallPath';
import MallMediaGallery from './MallMediaGallery';
import type { MediaGallery } from '../../../types/keepeekType';
import {
  brochuresGalleries,
  layoutGalleries,
  pictureGalleries,
  videoGalleries,
  virtualVisitsGalleries,
} from '../../../const';
import type { EmbeddedUrl } from '../../../types/embeddedUrlTypes';
import { galleriesHaveMedias } from '../../../utils/keepeekUtils';
import Loader from '../../common/Loader';

type Props = {
  embeddedUrls: EmbeddedUrl[],
  isEmbeddedLoading: boolean,
  shoppingCenterMedia: MediaGallery[],
  isMediaLoading: boolean,
}

type State = {
  tabs: { link: string, label: string }[],
  isLoading: boolean,
};

class MallMedia extends React.Component<Props, State> {
  state = {
    tabs: [],
    isLoading: true,
  };

  buildVisibleTabs = () => {
    const { embeddedUrls, shoppingCenterMedia } = this.props;
    const tabs = [];
    if (galleriesHaveMedias(layoutGalleries, shoppingCenterMedia)) {
      tabs.push({
        link: MALL_MEDIA_LAYOUT,
        label: <Translate value="mallData.MEDIA.LAYOUT" />,
      });
    }
    if (galleriesHaveMedias(pictureGalleries, shoppingCenterMedia)) {
      tabs.push({
        link: MALL_MEDIA_PICTURE,
        label: <Translate value="mallData.MEDIA.PICTURES" />,
      });
    }
    if (galleriesHaveMedias(brochuresGalleries, shoppingCenterMedia)) {
      tabs.push({
        link: MALL_MEDIA_BROCHURE,
        label: <Translate value="mallData.MEDIA.BROCHURES" />,
      });
    }
    if (galleriesHaveMedias(videoGalleries, shoppingCenterMedia)) {
      tabs.push({
        link: MALL_MEDIA_VIDEO,
        label: <Translate value="mallData.MEDIA.VIDEO" />,
      });
    }
    if (galleriesHaveMedias(virtualVisitsGalleries, shoppingCenterMedia)
      || (embeddedUrls && shoppingCenterMedia.length > 0 && embeddedUrls.length > 0)) {
      tabs.push({
        link: MALL_MEDIA_VISIT,
        label: <Translate value="mallData.MEDIA.VIRTUAL_VISITS" />,
      });
    }

    this.setState({ tabs, isLoading: this.props.isEmbeddedLoading || this.props.isMediaLoading });
  }

  componentDidMount() {
    this.buildVisibleTabs();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot: any) {
    if (prevProps.isMediaLoading !== this.props.isMediaLoading
      || prevProps.isEmbeddedLoading !== this.props.isEmbeddedLoading) {
      this.buildVisibleTabs();
    }
  }

  render() {
    const { embeddedUrls, shoppingCenterMedia } = this.props;
    if (this.state.isLoading) {
      return (
        <div className="loading-page">
          <Loader isLoading />
        </div>
      );
    }

    return (
      <TabRouter
        className="media-header"
        titleClassName="media-subtitle"
        underline
        tabs={this.state.tabs}
        router={
          <Switch>
            <Route
              path={MALL_MEDIA_LAYOUT}
              render={() =>
                (<MallMediaGallery
                  galleries={shoppingCenterMedia
                    .filter(gallery => layoutGalleries.includes(gallery.gallery))}
                />)
              }
            />
            <Route
              path={MALL_MEDIA_PICTURE}
              render={() =>
                (<MallMediaGallery
                  galleries={shoppingCenterMedia
                    .filter(gallery => pictureGalleries.includes(gallery.gallery))}
                />)
              }
            />
            <Route
              path={MALL_MEDIA_BROCHURE}
              render={() =>
                (<MallMediaGallery
                  galleries={shoppingCenterMedia
                    .filter(gallery => brochuresGalleries.includes(gallery.gallery))}
                />)
              }
            />
            <Route
              path={MALL_MEDIA_VIDEO}
              render={() =>
                (<MallMediaGallery
                  galleries={shoppingCenterMedia
                    .filter(gallery => videoGalleries.includes(gallery.gallery))}
                />)
              }
            />
            <Route
              path={MALL_MEDIA_VISIT}
              render={() =>
                (<MallMediaGallery
                  galleries={shoppingCenterMedia
                    .filter(gallery => virtualVisitsGalleries.includes(gallery.gallery))}
                  embeddedUrls={embeddedUrls}
                />)
              }
            />
            <Route
              path="*"
              render={() =>
                (<MallMediaGallery
                  galleries={shoppingCenterMedia
                    .filter(gallery => layoutGalleries.includes(gallery.gallery))}
                />)
              }
            />
          </Switch>
        }
      />
    );
  }
}

export default withRouter(MallMedia);
